var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-3"},[(_vm.client)?_c('ClientItem',{attrs:{"client":_vm.client}}):_c('ClientList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }